import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const NavLinkDefaultProps = {
  ...ClassNameDefaultProps,
  Icon: null,
  context: null,
  disabled: false,
  label: '',
  to: '#',
  variant: 'primary',
};

export const HeaderNavLinkPropTypes = {
  ...ClassNamePropTypes,
  Icon: PropTypes.node,
  context: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  to: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};
